export const color_grey = {
    0: "#727272",
    1: "#8C8B8B",
    2: "#C8C8C8",
    3: "#F2F2F2",
    4: "#F7F7F7",
    5: "#ffffff"
};

export const color_blue = {
    0: "#030323",
    1: "#030435",
    2: "#141689",
    3: "#ABC9E8",
    4: "#CDDFF2"
};

export const color_green = {
    0: "#153a0e",
    1: "#A3B732",
    2: "#B2DC25",
    3: "#E9E18C",
    4: "#E0EFAC"
};

export const color_red = {
    2: "#FF188B",
    3: "#FF86C2",
    4: "#FFB9DC"
};

export const color_yellow = {
    1: "#272205",
    2: "#FFE94D",
    3: "#FFF79A",
    4: "#FFFAE0"
};

export const color_purple = {
    2: "#5C0A82",
    3: "#C986FF",
    4: "#C8B3FF"
};

export const color_orange = {
    A: "#9e6119",
    0: "#FF9A26",
    1: "#FFC634",
    2: "#FFEAAA"
};
